import { render, staticRenderFns } from "./DeptSelector.vue?vue&type=template&id=1a2f4578&scoped=true"
import script from "./DeptSelector.vue?vue&type=script&lang=js"
export * from "./DeptSelector.vue?vue&type=script&lang=js"
import style0 from "./DeptSelector.vue?vue&type=style&index=0&id=1a2f4578&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a2f4578",
  null
  
)

export default component.exports